/**
 * Règle commune aux aperçus d'un `ShapeStyle` — la pastille du sélecteur de thème (`ThemeSwatch`) et
 * le carré du haut de la sidebar d'une forme (`ShapeSwatch`).
 *
 * Un aperçu transmet la COULEUR et le TYPE de trait (plein/pointillé), pas l'épaisseur exacte :
 * `ThemeStyle.borderWidth` monte à 20, ce qui refermerait un aperçu de quelques dizaines de pixels
 * sur lui-même. On la plafonne donc au sixième de la taille de l'aperçu, plancher à 1px.
 *
 * ⚠️ À utiliser avec `boxSizing: 'border-box'` sur l'aperçu : sans lui, `width`/`height` désignent la
 * boîte de CONTENU et la bordure s'ajoute autour, faisant varier la taille finale d'un style à
 * l'autre — des aperçus de tailles différentes désalignent tout ce qui les entoure.
 */
export function previewBorderWidth(borderWidth: number | undefined, size: number) {
	return Math.min(borderWidth ?? 1, Math.max(1, Math.round(size / 6)));
}
